import React from "react";
import { Link } from "react-router-dom";
import { SolidButton } from "../../../library/button";

const Index = () => {
  return (
    <div className="complete-container">
      <h1 className="complete-icon">
        <i class="fad fa-check"></i>
      </h1>
      <h3 className="complete-title">Dette ble en suksess!</h3>
      <p className="complete-description">
        Betaling og oppsett av miljø var vellykket, og du kan nå begynne å bruk
        Leadfind-plattformen.
      </p>
      <Link to="/dashboard/oversikt">
        <SolidButton size="regular" color="blue" title="Gå til dashboard" />
      </Link>
    </div>
  );
};

export default Index;
